// Central place to configure the public backend API base URL.
// Update this value when the CloudFront/API endpoint changes.

export const API_BASE_URL = "https://d11eyn3sv941kh.cloudfront.net";


